import { useEffect, useState } from 'react';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { collectionPath } from '../utils/firestoreCollections';

export function useUserRole(user) {
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!user || !user.uid) {
      setRole(null);
      return;
    }

    // If AuthContext already resolved the role from Firestore, use it
    if (user.role) {
      setRole(user.role);
      return;
    }
    
    // Fallback: direct doc lookup by UID, then email query
    const resolve = async () => {
      try {
        const snap = await getDoc(doc(db, collectionPath('users'), user.uid));
        if (snap.exists()) {
          setRole(snap.data().role || 'user');
          return;
        }
        // Email fallback for admin-created docs with non-UID document IDs
        if (user.email) {
          const emailSnap = await getDocs(
            query(collection(db, collectionPath('users')), where('email', '==', user.email))
          );
          if (!emailSnap.empty) {
            setRole(emailSnap.docs[0].data().role || 'user');
            return;
          }
        }
        console.warn('[useUserRole] User document not found:', user.uid);
        setRole('user');
      } catch (err) {
        console.error('[useUserRole] Error fetching user role:', err);
        setRole('user');
      }
    };
    resolve();
  }, [user]);

  return role;
}